import { safelyGetItem } from "storefront/lib/Storage";

export const LOCAL_STORAGE_KEY = "admin_overlay_hidden";

const isAdminOverlayHidden = () =>
  !!safelyGetItem(window.localStorage)(LOCAL_STORAGE_KEY) || false;

export default isAdminOverlayHidden;
